





















import Vue from 'vue';
export default Vue.extend({
  name: 'DashboardModalBase',
  props: {
    pcTitle: String,
    spTitle: String,
  },
});
